import { useEffect } from "react";
import { useParams } from "react-router-dom";

function RedirectToBackendPage() {

  const { filename } = useParams<string>();

  useEffect(() => {
    window.location.href = `/backend/static/${filename}`;
  }, []);

  return (
    <div>
    </div>
  );
}

export default RedirectToBackendPage;